module.exports = __webpack_public_path__ + "img/var_icon_backlight.018ac74d.svg";